////////////////////////////////////////////////////////////////////////////////
//                                                                             /
//                                                                             /
//  (C) Copyright 2026 Autodesk, Inc. All rights reserved.                     /
//                                                                             /
//                       ****  CONFIDENTIAL MATERIAL  ****                     /
//                                                                             /
//  The information contained herein is confidential, proprietary to           /
//  Autodesk, Inc., and considered a trade secret.  Use of this information    /
//  by anyone other than authorized employees of Autodesk, Inc. is granted     /
//  only under a written nondisclosure agreement, expressly prescribing        /
//  the scope and manner of such use.                                          /
//                                                                             /
////////////////////////////////////////////////////////////////////////////////

import React, {useState} from 'react';
import {
  CellDescription,
  ColumnLabels,
  ColumnValues,
  FlexColumn,
  RequireToken,
  RowSettings
} from "../CommonStyledComponents";
import Theme from "@adsk/alloy-react-theme";
import TextInput from "@adsk/alloy-react-text-input";
import SettingsTrigger from "./SettingsTrigger";
import {TaskTrigger} from "../Enums";
import Divider from "@adsk/alloy-react-divider";

const BulkSettingsName = (
  {name, trigger, startTime, onNameChange, onTriggerChange}: {
    name: string | undefined,
    trigger: TaskTrigger | undefined,
    startTime: Date | undefined,
    onNameChange?: (value: string) => void,
    onTriggerChange?: (trigger: TaskTrigger | undefined, startDate: Date | undefined) => void,
  }) => {
  const [internalName, setInternalName] = useState(name ?? '');

  function nameChange(): void {
    if (onNameChange) {
      onNameChange(internalName);
    }
  }

  return (
    <div>
      <RowSettings>
        <ColumnLabels>
          <h2 style={Theme.typography.heading2}>General</h2>
        </ColumnLabels>
        <ColumnValues>
          <CellDescription>
            <FlexColumn>
              <h3 style={Theme.typography.heading3}>Name<RequireToken>*</RequireToken></h3>
              <TextInput value={internalName}
                         placeholder={'Enter a task name...'}
                         onKeyDown={() => nameChange()}
                         onChange={v => setInternalName(v.target.value)}
                         onBlur={() => nameChange()}/>
            </FlexColumn>
          </CellDescription>
        </ColumnValues>
      </RowSettings>
      <Divider/>
      <RowSettings>
        <ColumnLabels>
          <h2 style={Theme.typography.heading2}>Trigger</h2>
        </ColumnLabels>
        <ColumnValues style={{marginTop: '1rem'}}>
          <SettingsTrigger
            recurrenceSettings={undefined}
            taskTrigger={trigger}
            startTime={startTime}
            allowRecurring={false}
            onStartTimeChanged={d => {
              if (onTriggerChange) {
                onTriggerChange(trigger, d);
              }
            }}
            onTriggerChanged={(t, d) => {
              if (onTriggerChange) {
                onTriggerChange(t, d);
              }
            }}/>
        </ColumnValues>
      </RowSettings>
    </div>
  );
};

export default BulkSettingsName;